// extracted by mini-css-extract-plugin
export var closed = "_b0-1";
export var resizer = "_b0-0";